<script>
import cloneDeep from "lodash/cloneDeep";
import fromPairs from "lodash/fromPairs";
import sortBy from "lodash/sortBy";
import moment from "moment";
import { MapClientType } from "@/common/util";
import macarons from "@/common/theme.json";

const mapTrainState = (state) => {
  if (state === "PENDING") {
    return "未完成";
  } else if (state === "ENDED") {
    return "已完成";
  } else if (state === "STARTED") {
    return "进行中";
  }
};
const mapMedalName = {
  精细刺激训练: "jingxiciji",
  视觉技巧训练: "shijuejiqiao",
  同时视: "tongshishi",
  融合视: "rongheshi",
  立体视: "litishi",
  Gabor训练: "gabor",
  对比敏感度训练: "duibimingandu",
  信息提取训练: "xinxitiqu",
};
const trainEyeTypeMap = {
  LEFT_EYE: "左眼",
  RIGHT_EYE: "右眼",
  NO_COVER: "双眼同时",
  WITH_GLASSES: "红蓝眼镜",
  UNKNOWN: "未知",
};
const supCalcCount = (start, end, source) => {
  const subArr = source.slice((start - 1) * 2, end * 2);
  let formCount = {
    jingxiciji: 0,
    shijuejiqiao: 0,
    gabor: 0,
    duibimingandu: 0,
    xinxitiqu: 0,
    rongheshi: 0,
    tongshishi: 0,
    litishi: 0,
  };
  if (subArr && subArr.length > 0) {
    subArr.forEach((item) => {
      formCount[mapMedalName[item.gameType]] =
        formCount[mapMedalName[item.gameType]] + 1;
    });
    for (let item in formCount) {
      if (item && formCount[item] && formCount[item] > 0) {
        formCount[item] = Math.floor(formCount[item] / 2);
      }
    }
  }
  return formCount;
};
const supCalcCountAll = (start, end, source) => {
  const subArr = source.slice(start - 1, end);

  let formCount = {
    jingxiciji: 0,
    shijuejiqiao: 0,
    gabor: 0,
    duibimingandu: 0,
    xinxitiqu: 0,
    rongheshi: 0,
    tongshishi: 0,
    litishi: 0,
  };
  if (subArr && subArr.length > 0) {
    subArr.forEach((item) => {
      formCount[mapMedalName[item.gameLabel]] =
        formCount[mapMedalName[item.gameLabel]] + 1;
    });
  }
  return formCount;
};
const supCalcCountFinshed = (start, end, source) => {
  const subArr = source.slice(start - 1, end);
  // console.log("><><", start, end, subArr);
  let formCount = {
    jingxiciji: 0,
    shijuejiqiao: 0,
    gabor: 0,
    duibimingandu: 0,
    xinxitiqu: 0,
    rongheshi: 0,
    tongshishi: 0,
    litishi: 0,
  };
  if (subArr && subArr.length > 0) {
    subArr.forEach((item) => {
      if (item.state === "ENDED") {
        formCount[mapMedalName[item.gameLabel]] =
          formCount[mapMedalName[item.gameLabel]] + 1;
      }
    });
  }
  return formCount;
};
export default {
  props: {
    userInfo: Object,
    CanEdit: Boolean,
  },

  data() {
    const patientId = this.$route.params.patientId;
    return {
      patientId,
      loading: true,
      shawOperationfaild: false,
      operationReverse: false,
      EditTreatment: false,
      checked: false,
      resetTreatment: false,
      trainHistorList: [],
      count: null,
      MaxCount: 60,
      courseId: "",
      tempTrainHistorList: [],
      remainCount: null,
      lastFinishedTrain: -1,
      formCount: {
        jingxiciji: 0,
        shijuejiqiao: 0,
        gabor: 0,
        duibimingandu: 0,
        xinxitiqu: 0,
        rongheshi: 0,
        tongshishi: 0,
        litishi: 0,
      },
      levelControl: {
        max: 0,
        min: 0,
        begin: 0,
        end: 0,
      },
      courseList: [],
      resetBegin: 0,
      resetEnd: 0,
      gameNumberStart: undefined,
      gameNumberEnd: undefined,
      courseTrainAutoLevel: [],
      buttonArray: [
        {
          text: "全部",
          key: "all",
        },
        {
          text: "未训练",
          key: "pending",
        },
        {
          text: "已训练",
          key: "finished",
        },
      ],
      showProportion: false,
      trainListProportion: [],
      courseIdProportion: undefined,
      visionTrainProportion: {},
      refreshProportion: true,
      formCountAll: {
        jingxiciji: 0,
        shijuejiqiao: 0,
        gabor: 0,
        duibimingandu: 0,
        xinxitiqu: 0,
        rongheshi: 0,
        tongshishi: 0,
        litishi: 0,
      },
      formCountFinshed: {
        jingxiciji: 0,
        shijuejiqiao: 0,
        gabor: 0,
        duibimingandu: 0,
        xinxitiqu: 0,
        rongheshi: 0,
        tongshishi: 0,
        litishi: 0,
      },
      trainProportion: {
        start: 1,
        end: 0,
      },
      lastedFinishTrainOperation: true,
      editTrainWeight: false,
      trainWeightList: [],
      value: undefined,
      beforeLevel: [],
      activeCourse2: "",
    };
  },
  computed: {
    activeLabel() {
      if (this.courseList.length > 0 && this.courseId) {
        const active = this.courseList.filter((o) => o.id === this.courseId);
        return active[0].label;
      } else {
        return "----";
      }
    },
    activeCourse() {
      if (this.courseList.length > 0 && this.courseId) {
        const active = this.courseList.filter((o) => o.id === this.courseId);
        return active[0].configured;
      } else {
        return false;
      }
    },
  },
  watch: {
    trainHistorList: function () {
      this.$nextTick(function () {
        const getPosition = sessionStorage.getItem("trainPosition");
        if (getPosition) {
          const contentElement = document.getElementsByClassName("content")[0];
          contentElement.scrollTop = parseInt(getPosition);
        }
        if (getPosition) {
          sessionStorage.removeItem("trainPosition");
        }
      });
    },
  },

  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const courseDataSession = sessionStorage.getItem("courseId");
      let courseId = "";
      let trainingCourseId = "";
      if (courseDataSession) {
        const dataParseSession = JSON.parse(courseDataSession);
        if (dataParseSession.patientId === this.patientId) {
          courseId = dataParseSession.courseId;
          trainingCourseId = dataParseSession.trainingCourseId;
        }
      }
      this.loading = true;
      let courseList = await this.$http.getPatientCourseList(this.patientId);
      if (courseList && courseList.data) {
        this.courseList = courseList.data.map((o) => {
          o.label = `疗程${o.courseNumber}`;
          return o;
        });
      }
      let trainList = await this.$http.getPatientTrainList(
        this.patientId,
        courseId
      );
      this.loading = false;
      if (trainList && trainList.content) {
        let newTableData = [];
        this.courseId =
          courseId ||
          (trainList.content.length > 0
            ? trainList.content[0].courseId
            : "");

        if (this.courseId) {
          const active = this.courseList.filter((o) => o.id === this.courseId);
          this.activeCourse2 = active[0].configured;
          const courseData = {
            patientId: this.patientId,
            courseId: this.courseId,
            trainingCourseId: trainingCourseId,
          };
          if (courseDataSession) {
            const dataParseSession = JSON.parse(courseDataSession);
            if (
              dataParseSession.patientId === this.patientId &&
              dataParseSession.trainingCourseId
            ) {
              courseData.trainingCourseId = dataParseSession.trainingCourseId;
            }
          }
          if (!courseId) {
            courseData.trainingCourseId = this.courseId;
          }
          sessionStorage.setItem("courseId", JSON.stringify(courseData));
        }
        let lastFinishedTrain = -1;
        trainList.content.forEach((item) => {
          let GameLevelData = JSON.parse(item.result);
          let totalScore = 0;
          let scoreList =
            item.state === "ENDED" &&
            GameLevelData &&
            GameLevelData.slice(1).map(
              (o) => (totalScore = totalScore + o.score)
            );
          if (item.state !== "PENDING") {
            lastFinishedTrain = item.courseNumber;
          }
          newTableData.push({
            courseNumber: item.courseNumber,
            initialLevel: item.initialLevel,
            gameType: item.gameLabel,
            gameLabel: item.gameLabel,
            gameName: item.gameName,
            gameId: item.gameId,
            modeType:
              item.modeList && item.modeList.length > 0
                ? `${item.modeList[0].name}等`
                : "",
            trainingAt:
              item.state !== "PENDING" && item.trainingAt
                ? moment(item.trainingAt).format("YYYY-MM-DD HH:mm")
                : "",
            totalScore:
              item.state === "ENDED"
                ? totalScore
                : item.state === "STARTED"
                ? "进行中"
                : "未完成",
            trainState: mapTrainState(item.state),
            trainingId: item.trainingId,
            state: item.state,
            result: item.result,
            locked: item.locked,
            autoInitialLevel: item.autoInitialLevel,
            realInitialLevel: item.realInitialLevel,
            maxBeginLevel: item.maxBeginLevel,
            clientType: MapClientType(item.clientType),
            exitedAt: item.exitedAt,
            exitType: item.exitType,
            trainingEyeType: item.trainingEyeType,
            stimulusLevel: item.stimulusLevel,
            clientVersion: item.clientVersion,
            isShowStimulusLevel: item.isShowStimulusLevel,
            quality: item.quality,
          });
        });
        if (lastFinishedTrain > -1) {
          newTableData[lastFinishedTrain - 1].lastFinishedTrain = true;
          this.lastFinishedTrain = lastFinishedTrain;
          if (lastFinishedTrain >= 2) {
            this.resetBegin =
              lastFinishedTrain % 2 === 0
                ? Math.ceil((lastFinishedTrain + 1) / 2)
                : Math.ceil(lastFinishedTrain / 2) + 1;
          } else if (lastFinishedTrain === 1) {
            this.resetBegin = 2;
          }
        } else {
          this.resetBegin = 1;
        }
        this.tempTrainHistorList = cloneDeep(newTableData);
        this.trainHistorList = newTableData;
        this.resetEnd = Math.floor(newTableData.length / 2);
        const getUnTrainCourse = [];
        const getCourseData =
          JSON.parse(sessionStorage.getItem("courseId")) || {};
        const trainingCourseId =
          getCourseData && getCourseData.trainingCourseId;
        for (let i = 0; i < this.courseList.length; i++) {
          if (this.courseList[i].id === trainingCourseId) {
            getUnTrainCourse.push(this.courseList[i]);
            if (this.courseList[i + 1]) {
              getUnTrainCourse.push(this.courseList[i + 1]);
            }
            break;
          }
        }
        const saveCourseData = {
          courseList: getUnTrainCourse,
          resetBegin: this.resetBegin,
          resetEnd: this.resetEnd,
          courseId: this.courseId,
        };
        if (
          getUnTrainCourse[0] &&
          getUnTrainCourse[0].id === trainingCourseId
        ) {
          console.log("emit");
          this.$emit("saveCourseData", saveCourseData);
        }

        if (lastFinishedTrain === newTableData.length) {
          let nextCourseId = this.courseId;
          for (let i = 0; i < this.courseList.length; i++) {
            if (this.courseList[i].id === this.courseId) {
              if (this.courseList[i + 1]) {
                nextCourseId = this.courseList[i + 1].id;
              }
              break;
            }
          }
          if (nextCourseId !== this.courseId) {
            const nextCourseList = await this.$http.getPatientTrainList(
              this.patientId,
              nextCourseId
            );
            if (nextCourseList && nextCourseList.content) {
              const nextGameStart = nextCourseList.content[0];
              if (nextGameStart.state !== "PENDING") {
                this.lastedFinishTrainOperation = false;
              }
            }
          }
        }
      }
    },
    pageClick(page) {
      this.encodeToUrl({
        page: page,
      });
    },
    onClickEditTreatment() {
      this.EditTreatment = true;
      const canEditList = {
        begin: this.resetBegin,
        end: this.resetEnd,
      };
      if (canEditList) {
        this.levelControl.begin = canEditList.begin;
        this.levelControl.end = canEditList.end;
        this.levelControl.min = canEditList.begin;
        this.levelControl.max = canEditList.end;
        this.gameNumberStart = (canEditList.begin - 1) * 2 + 1;
        this.gameNumberEnd = canEditList.end * 2;
        this.MaxCount = canEditList.end - canEditList.begin + 1;
        this.formCount = supCalcCount(
          canEditList.begin,
          canEditList.end,
          this.trainHistorList
        );
        console.log("????", this.formCount);
        let totalCount = 0;
        for (let item in this.formCount) {
          totalCount += this.formCount[item];
        }
        this.remainCount = totalCount;
        // this.remainCount = canEditList.end - canEditList.begin + 1;;
      }
    },
    onStartOrEndChange(value, keyName) {
      if (keyName === "start" && value > this.levelControl.end) {
        this.$message.warning("开始关卡数应小于结束关卡数，请重新输入关卡数！");
        this.onClickEditTreatment();
      } else if (keyName === "end" && value < this.levelControl.begin) {
        this.$message.warning("开始关卡数应小于结束关卡数，请重新输入关卡数！");
        this.onClickEditTreatment();
      } else {
        let start = this.levelControl.begin;
        let end = this.levelControl.end;
        this.MaxCount = end - start + 1;
      }
    },
    valueChange(event, oldValue, keyName) {
      if (event && event.path && event.path[0] && event.path[0].value != 0) {
        let start = this.levelControl.begin;
        let end = this.levelControl.end;
        if (keyName === "start") {
          start = event.path[0].value;
          this.gameNumberStart = (start - 1) * 2 + 1;
        } else if (keyName === "end") {
          end = event.path[0].value;
          this.gameNumberEnd = end * 2;
        }
        this.MaxCount = end - start + 1;
        this.formCount = supCalcCount(start, end, this.trainHistorList);
        let totalCount = 0;
        for (let item in this.formCount) {
          totalCount += this.formCount[item];
        }
        this.remainCount = totalCount;
      } else {
        if (keyName === "start") {
          this.gameNumberStart = (oldValue - 1) * 2 + 1;
        } else if (keyName === "end") {
          this.gameNumberEnd = oldValue * 2;
        }
      }
    },
    onCheckBoxChange(value) {
      if (value) {
        let listTemp = cloneDeep(this.trainHistorList);
        this.trainHistorList = listTemp.filter(
          (item) => item.state === "PENDING"
        );
      } else {
        this.trainHistorList = cloneDeep(this.tempTrainHistorList);
      }
    },
    handleChange(type) {
      let totalCount = 0;
      for (let item in this.formCount) {
        let v = this.formCount[item];
        if (v==undefined) v = 0;
        totalCount += v;
      }
      this.remainCount = totalCount;
    },
    async onSaveTreatment() {
      let totalCount = 0;
      const postData = {
        patientId: this.patientId,
        courseId: this.courseId,
      };
      for (let item in this.formCount) {
        totalCount += this.formCount[item];
        postData[item] = this.formCount[item];
      }
      if (totalCount !== this.MaxCount) {
        this.$message.warning("请保证已定制数量与总和数量一直！");
      } else {
        postData.begin = this.levelControl.begin;
        postData.end = this.levelControl.end;
        const result = await this.$http.saveEditCourse(postData);
        if (result === "success") {
          this.$message.success("保存成功！");
          this.EditTreatment = false;
          this.loadData();
        }
      }
    },
    onCourseDialogClose() {
      this.EditTreatment = false;
      this.formCount = {
        jingxiciji: 0,
        shijuejiqiao: 0,
        gabor: 0,
        duibimingandu: 0,
        xinxitiqu: 0,
        rongheshi: 0,
        tongshishi: 0,
        litishi: 0,
      };
    },
    onClick(row) {
      if (!this.CanEdit) {
        return;
      }

      const posution = document.getElementsByClassName("content")[0].scrollTop;
      const patientBirth = sessionStorage.getItem("activePatientBirth");
      let patientAge = 5;
      if (patientBirth) {
        patientAge = `${moment().diff(patientBirth, "years")}`;
      }
      sessionStorage.setItem("trainPosition", posution);
      if (row.state === "ENDED") {
        this.$router.push({
          path: `${this.$route.path}/finishedTrainDetail/${row.trainingId}/${row.gameId}/${patientAge}`,
        });
      } else if (row.state === "PENDING") {
        if (row.initialLevel) {
          this.$router.push({
            path: `${this.$route.path}/unplayTrainSet/${row.trainingId}/${
              row.gameType
            }/${row.gameId}/${row.initialLevel}/${row.trainingEyeType}/${
              this.userInfo.label
            }/${row.stimulusLevel || this.userInfo.stimulusLevel}`,
          });
        } else {
          const autoInitialLevel =
            row.maxBeginLevel && row.maxBeginLevel < row.autoInitialLevel
              ? row.maxBeginLevel
              : row.autoInitialLevel;
          this.$router.push({
            path: `${this.$route.path}/unplayTrainSet/${row.trainingId}/${
              row.gameType
            }/${row.gameId}/${autoInitialLevel}/${row.trainingEyeType}/${
              this.userInfo.label
            }/${row.stimulusLevel || this.userInfo.stimulusLevel}`,
          });
        }
      }
    },
    async onClickReverse() {
      const row = this.trainHistorList[this.lastFinishedTrain - 1];
      const operationData = {
        patientId: this.patientId,
        trainingId: row.trainingId,
      };
      const result = await this.$http.doctorSetPatientGameReverse(
        operationData
      );
      if (result === "success") {
        this.$message.success("操作成功！");
        this.loadData();
      }
    },
    onSeletCourse(courseId) {
      const courseData = {
        patientId: this.patientId,
        courseId: courseId,
      };
      const courseDataSession = sessionStorage.getItem("courseId");
      if (courseDataSession) {
        const dataParseSession = JSON.parse(courseDataSession);
        if (dataParseSession.patientId === this.patientId) {
          courseData.trainingCourseId = dataParseSession.trainingCourseId;
        }
      }
      sessionStorage.setItem("courseId", JSON.stringify(courseData));
      this.loadData();
    },
    //获得quto level初始值
    async onClickStartPlan() {
      if (this.activeCourse2) {
        let beforeCourseId = undefined;
        for (let item in this.courseList) {
          if (this.courseList[item].id === this.courseId && item > 0) {
            beforeCourseId = this.courseList[item - 1].id;
          }
        }
        const patientId = this.patientId;
        const courseId = this.courseId;
        if (courseId) {
          const result = await this.$http.getPatientAutolevel(
            patientId,
            courseId
          );
          if (beforeCourseId) {
            this.$http.getPatientCourseFormerLevel(courseId).then((result) => {
              this.beforeLevel = sortBy(result, "gameLabel");
            });
          } else {
            this.beforeLevel = [];
          }
          if (result.length > 0) {
            this.courseTrainAutoLevel = sortBy(result, "gameLabel");
            this.resetTreatment = true;
          } else {
            this.$message.warning("当前疗程尚未开始或未定制训练！");
          }
        }
      } else {
        this.$message.warning("请先定制该疗程！");
      }
    },
    //修改游戏auto level
    async resetPateintTreatment() {
      const patientId = this.patientId;
      const courseId = this.courseId;
      const data = this.courseTrainAutoLevel.map((o) => {
        return {
          gameId: o.gameId,
          autoLevel: o.autoLevel,
        };
      });
      const result = await this.$http.updaetPatientAutolevel(
        patientId,
        courseId,
        data
      );
      if (result === "success") {
        this.$message.success("操作成功！");
        this.loadData();
      }
      this.resetTreatment = false;
    },
    exitedAtFormtter(row) {
      let result = "";
      if (row.state === "ENDED") {
        const mapType = {
          CLOSE_GAME_EXIT: "中途退出",
          NORMAL_GAME_OVER_EXIT: "结束退出",
          OTHER: "其他",
          LOADING_EXIT: "加载时退出",
          PLAYBACK_REBUILD_EXIT: "校验结束退出",
        };
        if (row.exitedAt && row.trainingAt) {
          result =
            result +
            moment(row.exitedAt).diff(row.trainingAt, "seconds") +
            "秒";
        } else {
          result = result + "-- ";
        }
        if (row.exitType) {
          result = result + `（${mapType[row.exitType]}）`;
        }
      }

      return result;
    },
    trainEyeTypeFormtter(row) {
      if (trainEyeTypeMap[row.trainingEyeType]) {
        return trainEyeTypeMap[row.trainingEyeType];
      }
      return "";
    },
    gameTypeFormatter(row) {
      return row.gameType.replace("训练", "");
    },
    onProportionStartEndChange(list, isInit) {
      this.formCountAll = supCalcCountAll(
        this.trainProportion.start,
        this.trainProportion.end,
        list
      );
      this.formCountFinshed = supCalcCountFinshed(
        this.trainProportion.start,
        this.trainProportion.end,
        list
      );
      if (!isInit) {
        this.$nextTick(function () {
          this.visionTrainProportion.setOption({
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            series: [
              {
                name: "训练比例",
                type: "pie",
                radius: "55%",
                center: ["40%", "50%"],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },

                color: [
                  "#86C4EB",
                  "#C1BAEE",
                  "#86D49F",
                  "#86CAD4",
                  "#86A8D4",
                  "#F59498",
                  "#80E9E3",
                  "#63C9AC",
                ],
                data: [
                  {
                    value: this.formCountAll.jingxiciji,
                    name: "精细刺激",
                  },
                  {
                    value: this.formCountAll.shijuejiqiao,
                    name: "视觉技巧",
                  },
                  {
                    value: this.formCountAll.tongshishi,
                    name: "同时视",
                  },
                  {
                    value: this.formCountAll.rongheshi,
                    name: "融合视",
                  },
                  {
                    value: this.formCountAll.litishi,
                    name: "立体视",
                  },
                  {
                    value: this.formCountAll.gabor,
                    name: "Gabor",
                  },
                  {
                    value: this.formCountAll.duibimingandu,
                    name: "对比敏感度",
                  },
                  {
                    value: this.formCountAll.xinxitiqu,
                    name: "信息提取",
                  },
                ],
              },
            ],
          });
        });
      }
    },
    async onClickProportion() {
      this.trainListProportion = cloneDeep(this.trainHistorList);
      this.courseIdProportion = this.courseId;
      this.showProportion = true;
      this.lastedFinishTrainProportion = this.lastFinishedTrain;
      this.trainProportion = {
        start: 1,
        end: this.trainListProportion.length,
      };
      this.onProportionStartEndChange(this.trainListProportion, true);

      this.$nextTick(function () {
        // this.refreshProportion = true
        this.$echarts.registerTheme("myMacarons", macarons);
        const chartComponent = this.$refs.visionTrainProportion;
        let myChart = this.$echarts.init(chartComponent, "myMacarons");
        myChart.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
          },

          series: [
            {
              name: "训练比例",
              type: "pie",
              radius: "55%",
              center: ["40%", "50%"],
              // label: {
              //   show: false,
              //   position: "center"
              // },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },

              // labelLine: {
              //     show: false
              // },
              color: [
                "#86C4EB",
                "#C1BAEE",
                "#86D49F",
                "#86CAD4",
                "#86A8D4",
                "#F59498",
                "#80E9E3",
                "#63C9AC",
              ],
              data: [
                {
                  value: this.formCountAll.jingxiciji,
                  name: "精细刺激",
                },
                {
                  value: this.formCountAll.shijuejiqiao,
                  name: "视觉技巧",
                },
                {
                  value: this.formCountAll.tongshishi,
                  name: "同时视",
                },
                {
                  value: this.formCountAll.rongheshi,
                  name: "融合视",
                },
                {
                  value: this.formCountAll.litishi,
                  name: "立体视",
                },
                {
                  value: this.formCountAll.gabor,
                  name: "Gabor",
                },
                {
                  value: this.formCountAll.duibimingandu,
                  name: "对比敏感度",
                },
                {
                  value: this.formCountAll.xinxitiqu,
                  name: "信息提取",
                },
              ],
            },
          ],
        });
        this.visionTrainProportion = myChart;
      });
    },
    onOperationClick(row, key) {
      console.log("row", row, key, this.lastedFinishTrainProportion);
      if (key === "all") {
        this.trainProportion = {
          start: 1,
          end: this.trainListProportion.length,
        };
        this.onProportionStartEndChange(this.trainListProportion, false);
      } else if (key === "pending") {
        if (
          this.lastedFinishTrainProportion === this.trainListProportion.length
        ) {
          this.trainProportion = {
            start: 0,
            end: 0,
          };
        } else if (this.lastedFinishTrainProportion <= 0) {
          this.trainProportion = {
            start: 1,
            end: this.trainListProportion.length,
          };
        } else {
          this.trainProportion = {
            start: this.lastedFinishTrainProportion + 1,
            end: this.trainListProportion.length,
          };
        }
        this.onProportionStartEndChange(this.trainListProportion, false);
      } else if (key === "finished") {
        if (
          this.lastedFinishTrainProportion === this.trainListProportion.length
        ) {
          this.trainProportion = {
            start: 1,
            end: this.trainListProportion.length,
          };
        } else if (this.lastedFinishTrainProportion <= 0) {
          this.trainProportion = {
            start: 0,
            end: 0,
          };
        } else {
          this.trainProportion = {
            start: 1,
            end: this.lastedFinishTrainProportion,
          };
        }
        this.onProportionStartEndChange(this.trainListProportion, false);
      }
    },
    async onSeletCourseProportion(courseId) {
      let trainList = await this.$http.getPatientTrainList(
        this.patientId,
        courseId
      );
      this.trainListProportion = trainList.content;
      let lastedFinishTrainProportion = 0;
      trainList.content.forEach((item) => {
        if (item.state !== "PENDING") {
          lastedFinishTrainProportion = item.courseNumber;
        }
      });
      this.lastedFinishTrainProportion = lastedFinishTrainProportion;
      this.trainProportion = {
        start: this.lastedFinishTrainProportion > 0 ? 1 : 0,
        end: this.trainListProportion.length,
      };
      this.onProportionStartEndChange(this.trainListProportion, false);
    },
    onStartOrEndChangeProportion(value, keyName) {
      console.log(">>>>>>>>>aa", value, keyName);
      if (keyName === "start") {
        this.trainProportion.start = value;
        this.onProportionStartEndChange(this.trainListProportion, false);
      } else {
        this.trainProportion.end = value;
        this.onProportionStartEndChange(this.trainListProportion, false);
      }
    },
    async onClickWeight() {
      const result = await this.$http.getPatientTrainWeight(this.patientId);
      console.log(result);
      const DISINHIBITION =
        this.userInfo.configuration.label &&
        (this.userInfo.configuration.label == "AMBLYOPIA_DISINHIBITION" ||
          this.userInfo.configuration.label == "STRABISMUS_DISINHIBITION");
      this.trainWeightList = result.map((o) => {
        if (!o.weight && o.weight != "0") {
          o.weight = 1;
        }
        if (typeof o.enabled !== "boolean") {
          o.enabled = true;
        }
        if (DISINHIBITION) {
          if (
            ["推箱子", "框套动物", "打靶", "俄罗斯方块"].indexOf(o.gameName) >
            -1
          ) {
            o.DISINHIBITION = true;
          }
        }
        return o;
      });
      this.editTrainWeight = true;
    },
    hideEdit() {
      this.editTrainWeight = false;
    },
    async saveEdit() {
      const data = this.trainWeightList.map((o) => {
        return {
          gameId: o.gameId,
          enabled: o.enabled,
          weight: o.weight,
        };
      });
      const result = await this.$http.setPatientTrainWeight(
        this.patientId,
        data
      );
      if (result) {
        this.$message.success("操作成功！");
      }
      this.editTrainWeight = false;
    },
    userBeforeLevel() {
      const beforeLevel = cloneDeep(this.beforeLevel);
      const tempMapBefore = beforeLevel.map((o) => {
        return [o.gameId, o.autoLevel];
      });
      const MapBefore = fromPairs(tempMapBefore);
      // console.log(">>>>>>>>>>", MapBefore);
      this.courseTrainAutoLevel = this.courseTrainAutoLevel.map((o) => {
        if (MapBefore[o.gameId]) {
          o.autoLevel = MapBefore[o.gameId];
        }
        return o;
      });
    },
  },
};
</script>

<template>
  <div class="PatientTrainHistoryIndex">
    <operationDialog
      class="editCourseDialog"
      title="疗程定制"
      :Visible="EditTreatment"
      width="576px"
      :center="true"
      @close="onCourseDialogClose"
      @confirm="onSaveTreatment"
      btnText="确定"
    >
      <span class="noticeItem">
        <i class="el-icon-warning warinigIcon"></i>定制第
        <el-input-number
          :controls="false"
          class="ctrlNumberInput"
          v-model="levelControl.begin"
          :min="levelControl.min"
          :max="levelControl.max"
          @change="(value) => onStartOrEndChange(value, 'start')"
          @input.native="
            (event) => valueChange(event, levelControl.begin, 'start')
          "
        />次至第
        <el-input-number
          :controls="false"
          class="ctrlNumberInput"
          v-model="levelControl.end"
          :min="levelControl.min"
          :max="levelControl.max"
          @change="(value) => onStartOrEndChange(value, 'end')"
          @input.native="(event) => valueChange(event, levelControl.end, 'end')"
        />
        次的训练，对应训练方案序号为{{ gameNumberStart }} ~ {{ gameNumberEnd }}
      </span>
      <span class="noticeItem">
        本次定制训练各类别的总和应为
        <span class="numberStyle">{{ MaxCount }}</span> 次，当前已定制训练次数：
        <span class="numberStyle">{{ remainCount }}</span> 次
      </span>
      <div class="line"></div>
      <el-row :gutter="24">
        <el-col :span="4">
          <div class="item">训练次数</div>
        </el-col>
        <el-col :span="4">
          <span class="item">精细刺激</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.jingxiciji"
            class="dialogNumberInput"
            key="jingxiciji"
            controls-position="right"
            :min="0"
            :max="MaxCount"
            size="mini"
            @change="handleChange('jingxiciji')"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">视觉技巧</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.shijuejiqiao"
            class="dialogNumberInput"
            controls-position="right"
            @change="handleChange('shijuejiqiao')"
            :min="0"
            :max="MaxCount"
            size="mini"
            key="shijuejiqiao"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4" :offset="4">
          <span class="item">Gabor</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.gabor"
            key="gabor"
            class="dialogNumberInput"
            controls-position="right"
            @change="handleChange('gabor')"
            :min="0"
            :max="MaxCount"
            size="mini"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">对比敏感度</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.duibimingandu"
            class="dialogNumberInput"
            controls-position="right"
            key="duibimingandu"
            @change="handleChange('duibimingandu')"
            :min="0"
            :max="MaxCount"
            size="mini"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4" :offset="4">
          <span class="item">信息提取</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.xinxitiqu"
            class="dialogNumberInput"
            key="xinxitiqu"
            controls-position="right"
            @change="handleChange('xinxitiqu')"
            :min="0"
            :max="MaxCount"
            size="mini"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">融合视</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.rongheshi"
            key="rongheshi"
            class="dialogNumberInput"
            controls-position="right"
            @change="handleChange('rongheshi')"
            :min="0"
            :max="MaxCount"
            size="mini"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4" :offset="4">
          <span class="item">同时视</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.tongshishi"
            class="dialogNumberInput"
            key="tongshishi"
            controls-position="right"
            @change="handleChange('tongshishi')"
            :min="0"
            :max="MaxCount"
            size="mini"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">立体视</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.litishi"
            class="dialogNumberInput"
            key="litishi"
            controls-position="right"
            @change="handleChange('litishi')"
            :min="0"
            :max="MaxCount"
            size="mini"
          ></el-input-number>
        </el-col>
      </el-row>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="dialogConfirmButton" @click="onSaveTreatment">确 定</el-button>
      </span>-->
    </operationDialog>
    <operationDialog
      class="resetPlanDialog"
      :title="`${activeLabel}起始关卡（Auto）`"
      :Visible="resetTreatment"
      width="500px"
      :center="true"
      @close="resetTreatment = false"
      @confirm="resetPateintTreatment"
      btnText="确定"
    >
      <div class="resetContent">
        <el-row v-if="beforeLevel.length > 0">
          <el-col :span="24" style="text-align: right">
            <el-button type="text" size="mini" @click="userBeforeLevel"
              >同步历史疗程起始关卡</el-button
            >
          </el-col>
        </el-row>
        <el-row
          :gutter="24"
          v-for="(gameAuto, index) in courseTrainAutoLevel"
          :key="gameAuto.gameId + index"
        >
          <el-col :span="7">
            <div class="item">{{ gameAuto.gameLabel }}</div>
          </el-col>
          <el-col :span="11">
            <span class="item">{{ gameAuto.gameName }}</span>
          </el-col>
          <el-col :span="6">
            <el-input-number
              v-model="gameAuto.autoLevel"
              class="dialogNumberInput"
              :controls="false"
              :min="0"
              :max="10000"
              size="mini"
            ></el-input-number>
          </el-col>
        </el-row>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="dialogConfirmButton" @click="resetPateintTreatment">确 定</el-button>
      </span>-->
    </operationDialog>
    <operationDialog
      class="showProportion"
      title="疗程训练比例"
      :Visible="showProportion"
      width="510px"
      :center="true"
      @close="showProportion = false"
      :hideSave="true"
    >
      <span class="noticeItem">
        疗程选择：
        <el-select
          class="courseSelect"
          size="small"
          v-model="courseIdProportion"
          placeholder="请选择"
          @change="onSeletCourseProportion"
        >
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </span>
      <span class="noticeItem">
        序号选择：
        <el-input-number
          :controls="false"
          class="dialogNumberInput"
          v-model="trainProportion.start"
          size="small"
          @change="(value) => onStartOrEndChangeProportion(value, 'start')"
        />至
        <el-input-number
          :controls="false"
          size="small"
          class="dialogNumberInput"
          v-model="trainProportion.end"
          @change="(value) => onStartOrEndChangeProportion(value, 'end')"
        />
        <textButtonGroup
          class="buttonArray"
          :buttonArray="buttonArray"
          @onOperationClick="onOperationClick"
        />
      </span>

      <div class="line" />
      <el-row :gutter="24">
        <el-col :span="24">
          <span class="item title">训练比例</span>
        </el-col>
        <el-col :span="24">
          <div
            v-if="refreshProportion"
            ref="visionTrainProportion"
            :style="{ width: '400px', height: '300px', margin: 'auto' }"
          ></div>
        </el-col>
      </el-row>
      <div class="line" />
      <el-row :gutter="24">
        <el-col :span="24">
          <span class="item title">训练完成度</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">精细刺激</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#86C4EB"
            :stroke-width="15"
            :percentage="
              formCountAll.jingxiciji > 0
                ? Math.ceil(
                    (formCountFinshed.jingxiciji / formCountAll.jingxiciji) *
                      100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.jingxiciji }}/{{
              formCountAll.jingxiciji
            }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">视觉技巧</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#C1BAEE"
            :stroke-width="15"
            :percentage="
              formCountAll.shijuejiqiao > 0
                ? Math.ceil(
                    (formCountFinshed.shijuejiqiao /
                      formCountAll.shijuejiqiao) *
                      100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.shijuejiqiao }}/{{
              formCountAll.shijuejiqiao
            }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">同时视</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#86D49F"
            :stroke-width="15"
            :percentage="
              formCountAll.tongshishi > 0
                ? Math.ceil(
                    (formCountFinshed.tongshishi / formCountAll.tongshishi) *
                      100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.tongshishi }}/{{
              formCountAll.tongshishi
            }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">融合视</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#86CAD4"
            :stroke-width="15"
            :percentage="
              formCountAll.rongheshi > 0
                ? Math.ceil(
                    (formCountFinshed.rongheshi / formCountAll.rongheshi) * 100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.rongheshi }}/{{ formCountAll.rongheshi }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">立体视</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#86A8D4"
            :stroke-width="15"
            :percentage="
              formCountAll.litishi > 0
                ? Math.ceil(
                    (formCountFinshed.litishi / formCountAll.litishi) * 100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.litishi }}/{{ formCountAll.litishi }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">Gabor</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#F59498"
            :stroke-width="15"
            :percentage="
              formCountAll.gabor > 0
                ? Math.ceil((formCountFinshed.gabor / formCountAll.gabor) * 100)
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.gabor }}/{{ formCountAll.gabor }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">对比敏感度</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#80E9E3"
            :stroke-width="15"
            :percentage="
              formCountAll.duibimingandu > 0
                ? Math.ceil(
                    (formCountFinshed.duibimingandu /
                      formCountAll.duibimingandu) *
                      100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.duibimingandu }}/{{
              formCountAll.duibimingandu
            }}</span
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="elRow">
        <el-col :span="20">
          <span class="item">信息提取</span>
          <el-progress
            class="progress"
            :show-text="false"
            color="#63C9AC"
            :stroke-width="15"
            :percentage="
              formCountAll.xinxitiqu > 0
                ? Math.ceil(
                    (formCountFinshed.xinxitiqu / formCountAll.xinxitiqu) * 100
                  )
                : 0
            "
          ></el-progress>
        </el-col>
        <el-col :span="4">
          <span class="item"
            >{{ formCountFinshed.xinxitiqu }}/{{ formCountAll.xinxitiqu }}</span
          >
        </el-col>
      </el-row>
    </operationDialog>
    <operationDialog
      title="训练权重"
      :Visible="editTrainWeight"
      class="editDialog"
      width="600px"
      @close="hideEdit"
      :center="true"
      btnText="提交"
      @confirm="saveEdit"
    >
      <el-alert
        class="existUserDialogAlert"
        title="训练游戏的权重值为0～10"
        type="warning"
        show-icon
        :closable="false"
      ></el-alert>
      <el-row style="background: #fafafa">
        <el-col :span="6">类别</el-col>
        <el-col :span="10">游戏名称</el-col>
        <el-col :span="5">权重值</el-col>
        <el-col :span="3" style="text-align: center">启用</el-col>
      </el-row>
      <el-row
        class="gameWeightRow"
        v-for="gameItem in trainWeightList"
        :key="gameItem.gameId"
      >
        <el-col :span="6">{{ gameItem.labelName }}</el-col>
        <el-col :span="10">
          {{ gameItem.gameName }}
          <span
            v-if="gameItem.DISINHIBITION"
            style="color: red; font-size: 12px"
            >（不适用于脱抑制训练）</span
          >
        </el-col>
        <el-col :span="5">
          <el-input-number
            style="width: 100px"
            size="small"
            :max="10"
            :min="0"
            :step="1"
            :step-strictly="true"
            :controls="false"
            v-model="gameItem.weight"
            type="text"
          />
        </el-col>
        <el-col :span="3" style="text-align: center">
          <el-switch
            v-model="gameItem.enabled"
            active-color="#13ce66"
          ></el-switch>
        </el-col>
      </el-row>
    </operationDialog>
    <elementButton
      class="resetPlanButton"
      v-show="CanEdit"
      @click="onClickStartPlan"
      size="medium"
      type="primary"
      >起始关卡配置</elementButton
    >
    <elementButton
      class="resetPlanButton"
      v-show="CanEdit"
      @click="onClickProportion"
      size="medium"
      type="primary"
      >疗程训练比例</elementButton
    >
    <elementButton
      class="resetPlanButton"
      v-show="CanEdit"
      @click="onClickWeight"
      size="medium"
      type="primary"
      >训练权重</elementButton
    >
    <elementButton
      v-show="activeCourse2 == false"
      class="resetPlanButton forgetStimulusLevelAlert"
      size="medium"
      type="danger"
      ><i class="el-icon-warning-outline"></i
      >该疗程尚未配置！请先定制疗程</elementButton
    >
    <span class="trainPlanRight">
      疗程:
      <el-select
        class="courseSelect"
        v-model="courseId"
        placeholder="请选择"
        @change="onSeletCourse"
      >
        <el-option
          v-for="item in courseList"
          :key="item.id"
          :label="item.label"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-checkbox v-model="checked" @change="onCheckBoxChange"
        >未训练</el-checkbox
      >
      <el-button
        :disabled="
          !(
            this.resetBegin < this.resetEnd &&
            this.resetEnd - this.resetBegin > 1
          )
        "
        v-if="CanEdit"
        size="medium"
        class="addEditRangeButton"
        @click="onClickEditTreatment"
        >疗程定制</el-button
      >
    </span>
    <!-- <DialogForm
      v-if="shawOperationfaild"
      class="OperationfaildDialog"
      formTitle="该患者当前疗程使用反操作次数已超过限制"
      @close="shawOperationfaild = false"
      @submitForm="shawOperationfaild = false"
      keyOperation="shawOperationfaild"
      confirmButton="确认"
    />-->
    <DialogForm
      v-if="operationReverse"
      class="OperationfaildDialog"
      formTitle="请确认将该关卡设置为未训练状态？"
      @close="operationReverse = false"
      @submitForm="onClickReverse"
      keyOperation="shawOperationfaild"
      confirmButton="确认"
    />
    <el-table
      :data="trainHistorList"
      @row-click="onClick"
      v-loading="loading"
      class="trainHistoryTable"
      :cell-style="{ 'padding-left': '5px' }"
      header-cell-class-name="trainHistorListHeaderCell"
      cell-class-name="trainHistorListBodyCell"
    >
      <el-table-column
        prop="courseNumber"
        align="left"
        label="序号"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="gameType"
        align="left"
        label="训练类别"
        min-width="100"
        :formatter="gameTypeFormatter"
      ></el-table-column>
      <el-table-column
        prop="gameName"
        align="left"
        label="训练游戏"
        min-width="90"
      ></el-table-column>
      <el-table-column
        prop="trainingEyeType"
        align="left"
        label="训练眼别"
        :formatter="trainEyeTypeFormtter"
        width="90"
      ></el-table-column>
      <el-table-column
        prop="clientType"
        align="left"
        label="训练终端"
        width="135"
      >
        <template slot-scope="scope">
          <div class="trainTitleCell">{{ scope.row.clientType }}</div>
          <div class="trainTitleCell">
            版本号：{{ scope.row.clientVersion || "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="trainingAt"
        align="left"
        label="训练时间"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="exitedAt"
        align="left"
        label="训练时长(退出方式)"
        :formatter="exitedAtFormtter"
        min-width="135"
      ></el-table-column>
      <el-table-column
        prop="initialLevel"
        align="left"
        label="起始关卡"
        width="75"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.state === 'ENDED'">{{
            scope.row.realInitialLevel
          }}</span>
          <span v-else-if="scope.row.initialLevel">{{
            scope.row.initialLevel
          }}</span>
          <span
            v-else-if="
              scope.row.maxBeginLevel &&
              scope.row.maxBeginLevel < scope.row.autoInitialLevel
            "
            >{{ scope.row.maxBeginLevel }} (max)</span
          >
          <span v-else>{{ scope.row.autoInitialLevel }} (auto)</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="quality"
        align="left"
        label="评估值"
        width="65"
      ></el-table-column>
      <el-table-column
        prop="stimulusLevel"
        align="left"
        label="刺激等级"
        width="65"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.isShowStimulusLevel && scope.row.stimulusLevel"
            >{{ scope.row.stimulusLevel }}</span
          >
          <span
            v-else-if="scope.row.isShowStimulusLevel && userInfo.stimulusLevel"
            >{{ userInfo.stimulusLevel }} (auto)</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="trainState"
        align="left"
        label="训练状态"
        width="75"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.lastFinishedTrain && lastedFinishTrainOperation"
            @click.stop="CanEdit && (operationReverse = true)"
          >
            <el-button
              :disabled="!CanEdit"
              type="primary"
              size="small"
              class="submitButton"
              >反操作</el-button
            >
          </span>
          <span v-else>{{ scope.row.trainState }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="locked" align="left" label="锁定" width="85">
        <template slot="header">
          <el-tooltip
            class="item"
            effect="light"
            content="锁定后，训练内容不受自动调节功能影响，训练师仍可在详情页面配置训练内容"
            placement="bottom"
          >
            <span>
              锁定
              <i class="el-icon-warning" />
            </span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.locked">
            <img class="lockIcon" src="@/assets/lock.svg" />
          </span>
          <span v-else>
            <img class="lockIcon" src="@/assets/unlock.png" />
          </span>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.PatientTrainHistoryIndex {
  .trainHistoryTable {
    margin: 20px auto;
    border: 1px;
    width: 98%;
    position: unset;
    overflow: unset;

    .checkBoxLabel {
      color: #303133;

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__header-wrapper,
    .el-table__footer-wrapper {
      position: sticky;
      top: 0;
      z-index: 500;
    }

    .trainTitleCell {
      // line-height: 20px;
      // margin-bottom: -10px;
      padding: 0;
    }

    .trainHistorListHeaderCell {
      padding-left: 0px;
      padding-right: 0px;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      background-color: #fafafa !important;

      > .cell {
        padding-left: 0px;
        padding-right: 0px;
      }
    }

    .trainHistorListBodyCell {
      > .cell {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
  .forgetStimulusLevelAlert {
    display: inline-block;
    // width: 250px;
    // margin-top: 10px;
    border-color: #e6a23c !important;
    height: 36px;
    margin-left: 10px;
    background-color: #e6a23c !important;
    color: #fff;
    border-radius: 5px !important;
  }
  .editDialog {
    .el-dialog__body {
      padding-left: 5px;
      padding-bottom: 5px;
      padding-top: 10px;
      max-height: 350px;
      overflow-y: auto;
    }

    .existUserDialogAlert {
      margin: 15px;
      width: auto;
      // padding-left: 10px;
      height: 36px;
      background: rgba(255, 251, 230, 1);
      border-radius: 4px;
      border: 1px solid rgba(255, 229, 143, 1);

      .el-alert__title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }

    .el-row {
      line-height: 33px;
      margin: 5px 15px;
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }
  }

  .trainPlanRight {
    float: right;
    margin: 10px;

    .el-checkbox {
      color: #000000;
    }

    .addEditRangeButton {
      margin-left: 10px;
      margin-right: 10px;
      border-color: #00c1de;
      background-color: #00c1de;
      color: #fff;
    }

    .courseSelect {
      width: 110px;
      margin: 0 5px;
    }
  }

  .resetPlanButton {
    float: left;
    margin: 10px;
    margin-left: 1%;
    border-color: #00c1de;
  }

  .editCourseDialog {
    .el-dialog {
      border-radius: 12px;
    }

    .dialogNumberInput {
      width: 95px;
      height: 27px;
    }

    .item {
      line-height: 31px;
      font-size: 14px;
      color: #0a2136;
      letter-spacing: 0;
    }

    .noticeItem {
      // text-align: center;
      line-height: 31px;
      font-size: 14px;
      // color: rgba(255, 0, 0, 0.65);
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
      margin-left: 40px;

      .numberStyle {
        color: #00c1de;
        font-size: 16px;
      }

      .warinigIcon {
        margin: 0 2px 0 -15px;
        color: #00c1de;
      }
    }

    .line {
      height: 1px;
      background-color: #e4e8eb;
      width: 90%;
      margin: 0 auto 10px;
    }

    .el-dialog--center .el-dialog__body {
      padding: 0 10px 10px;
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }

    .ctrlNumberInput {
      width: 40px;

      .el-input {
        display: inline-block;

        input {
          width: 35px;
          height: 30px;
          padding: 0px;
        }
      }
    }
  }

  .resetPlanDialog {
    .el-dialog {
      border-radius: 12px;

      .el-dialog__headerbtn {
        font-size: 23px;
      }
    }

    .el-dialog--center .el-dialog__body {
      max-height: 325px;
      min-height: 150px;
      overflow-y: scroll;
    }

    .el-dialog--center .el-dialog__body {
      padding-bottom: 0;
      padding-top: 10px;
    }

    .resetContent {
      text-align: center;

      .dialogNumberInput {
        width: 95px;
        height: 27px;
      }

      // margin-top: 30px;
      .resetText {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 27px;
      }

      .levelItem {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(80, 86, 89, 1);
        line-height: 22px;

        .ctrlNumberInput {
          width: 55px;
        }
      }

      .line {
        height: 1px;
        background-color: #e4e8eb;
        width: 90%;
        margin: 16px auto 27px;
      }

      .noticeItem {
        width: 307px;
        margin: 20px auto 10px;

        .el-alert__title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
        }
      }
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }
  }

  .showProportion {
    .el-dialog {
      border-radius: 12px;
    }
    .el-dialog--center .el-dialog__body {
      padding-bottom: 10px;
      padding-top: 10px;
      height: 400px;
      overflow-y: auto;
    }

    .elRow {
      margin-top: 10px;
    }

    .line {
      height: 1px;
      background-color: #e4e8eb;
      width: 95%;
      margin: 10px auto 10px;
    }

    .dialogNumberInput {
      width: 65px;
      margin-left: 5px;
      margin-right: 5px;
      // height: 27px;
    }

    .title {
      font-size: 16px !important;
      color: #000000 !important;
      width: 100px !important;
    }

    .item {
      // line-height: 31px;
      display: inline-block;
      font-size: 14px;
      color: #595959;
      letter-spacing: 0;
      width: 70px;
    }

    .progress {
      display: inline-block;
      width: 280px;
      line-height: 25px;
      margin-left: 10px;
    }

    .noticeItem {
      margin: 10px auto 10px;
      display: inline-block;
      width: 100%;

      .numberStyle {
        color: #00c1de;
        font-size: 16px;
      }

      .buttonArray {
        display: inline-block;
        margin-left: 10px;
      }
    }
  }

  .submitButton {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .OperationfaildDialog {
    .Dialog {
      padding-top: 40px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/trainPlanPage.vue